import { fetchTaxononmySwellEvents } from '../common/api/kbyg';

export const FETCH_SWELL_EVENTS = 'FETCH_SWELL_EVENTS';
export const FETCH_SWELL_EVENTS_SUCCESS = 'FETCH_SWELL_EVENTS_SUCCESS';
export const FETCH_SWELL_EVENTS_FAILURE = 'FETCH_SWELL_EVENTS_FAILURE';

export const fetchSwellEvents = (id, type) => async dispatch => {
  dispatch({
    type: FETCH_SWELL_EVENTS,
  });

  try {
    const { data } = await fetchTaxononmySwellEvents(id, type);
    dispatch({
      type: FETCH_SWELL_EVENTS_SUCCESS,
      events: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SWELL_EVENTS_FAILURE,
      error,
    });
  }
};
